/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';


import * as actions from '../../actions';
import * as selectors from '../../selectors';


const Divider = () => (
  <i className="right angle icon divider"></i>
);


class Breadcrumbs extends Component {
  constructor(props) {
    super(props);
    this.handleOnCrumbClick = this.handleOnCrumbClick.bind(this);
  }


  handleOnCrumbClick(breadcrumb) {
    const { selectBreadcrumb } = this.props;
    return () => {
      selectBreadcrumb(breadcrumb)
    }
  }


  renderBreadcrumbs() {
    const { breadcrumbs, selectedKey } = this.props;
    return (breadcrumbs || []).map(crumb => {
      const { key_level, name } = crumb;
      return (
        <span key={key_level}>
          <Divider />
          {selectedKey !== key_level
            ? <a className="ui section link ht-breadcrumb" onClick={this.handleOnCrumbClick(crumb)}>{name}</a>
            : <div className="active section">{name}</div>
          }
        </span>
      );
    })
  }


  render() { 
    const { selectHome } = this.props;

    return (
      <div className="ui breadcrumb">
        <a className="section" onClick={selectHome}><FormattedMessage id="admin.hotkey_template.form.home" defaultMessage="Home" /></a>
        {this.renderBreadcrumbs()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { breadcrumbs, key_level } = selectors.getSelectedTab(state);

  return {
    selectedKey: key_level,
    breadcrumbs: isEmpty(breadcrumbs) 
                  ? selectors.getDefaultBreadcrumbs(state)
                  : breadcrumbs
  }
}


function mapDispatchToProps(dispatch) {
  const { selectHome, selectBreadcrumb } = actions;

  return bindActionCreators({
    selectHome,
    selectBreadcrumb
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
